module.exports = __webpack_public_path__ + "img/dexterity.868671a5.svg";